<my-abuse-list-table viewType="admin"></my-abuse-list-table>
